import axios from "axios";

// La API se expone en el mismo dominio mediante Nginx.
export const api = axios.create({
  baseURL: "/api",
});
